<div class="profile-menu-dialog-container" ngClass.lt-md="mobile">
    
    <a class="btn-close" (click)="close()">
        <mat-icon fontSet="phr-iconset" class="phr-iconset-PHR-Cerrar"></mat-icon> 
    </a>

    <app-profile-menu [dialog]="mdDialogRef"></app-profile-menu>

</div>